import React, { useEffect, useState } from "react";
import Typist from "react-typist";
import { Link as ScrollLink } from "react-scroll";
import "./Home.css";

function Home() {
  const [count, setCount] = useState(1);
  useEffect(() => {
    setCount(1);
  }, [count]);
  return (
    <>
      <div className="homepage-container"></div>
      <div className="homepage-content-container">
        <div className="opening-text">
          <h1 className="hi-message">Hi! I'm Erik.</h1>
          <div className="typist-container">
            I'm a&nbsp;
            {count ? (
              <Typist
                onTypingDone={() => setCount(0)}
                cursor={{ blink: false, hideWhenDone: true }}
              >
                JavaScript developer
                <Typist.Backspace count={20} delay={1500} />
                learner
                <Typist.Backspace count={7} delay={1500} />
                grower
                <Typist.Backspace count={7} delay={1500} />
                teamplayer
                <Typist.Backspace count={10} delay={1500} />
              </Typist>
            ) : (
              ""
            )}
          </div>
          <ScrollLink
            className="arrow-container"
            smooth={true}
            duration={250}
            to={`box-1`}
          >
            <img
              className="arrow-down"
              alt="arrow"
              src="https://res.cloudinary.com/dsgpdeonk/image/upload/v1623242384/arrow-down-sign-to-navigate_hdp7bk.svg"
            ></img>{" "}
          </ScrollLink>
        </div>
      </div>
    </>
  );
}

export default Home;
